import { render, staticRenderFns } from "./ClaimSelectionActions.vue?vue&type=template&id=67ddcae6&scoped=true&lang=pug&"
import script from "./ClaimSelectionActions.vue?vue&type=script&lang=js&"
export * from "./ClaimSelectionActions.vue?vue&type=script&lang=js&"
import style0 from "./ClaimSelectionActions.vue?vue&type=style&index=0&id=67ddcae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ddcae6",
  null
  
)

export default component.exports